import type { VsmContext, PageConfigEntry, PageConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { ImagePlaceholderPageConfig } from '../types'
import { IMAGE_PLACEHOLDER_COMPONENTS_TYPES } from '../imagePlaceholderComponentTypes'
import { name } from '../symbols'

const IMAGE_PLACEHOLDER_TYPES_SET: ReadonlySet<string> = new Set(IMAGE_PLACEHOLDER_COMPONENTS_TYPES)

const imagePlaceholderPageConfig: PageConfigFn<ImagePlaceholderPageConfig> = ({ api }: VsmContext) => {
	const hasComponents = api.components.hasComponentWithPredicate((comp) =>
		IMAGE_PLACEHOLDER_TYPES_SET.has(comp.componentType as string)
	)

	if (!hasComponents) {
		return { shouldLoadPageFeature: false }
	}

	const protocol = api.env.isHttps() ? 'https:' : 'http:'
	const publicTopology = api.env.getPublicTopology()
	const staticMediaUrl = `${protocol}${publicTopology?.staticMediaUrl ?? ''}`

	return {
		shouldLoadPageFeature: true,
		pageConfig: {
			staticMediaUrl,
			isSEOBot: api.env.isInSeo(),
		},
	}
}

export const pageConfig: PageConfigEntry<ImagePlaceholderPageConfig> = {
	name,
	configFactory: imagePlaceholderPageConfig,
	experiment: 'specs.thunderbolt.vsmPageConfigs',
}
